import { MergeTypeRounded } from '@mui/icons-material';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { FieldNames } from 'v2/core/entities/fields';
import { shallow } from 'zustand/shallow';
import { trackQuickFiltersEvents } from '../helpers/trackQuickFiltersEvents';
import { useChartTooltipStore } from '../hooks';

interface MergeWithAnotherReasonProps {
  isMenuItem?: boolean;
}

export const MergeWithAnotherReason = ({
  isMenuItem = false,
}: MergeWithAnotherReasonProps) => {
  const { payload, setData, fieldName, shouldShowMergeReason } =
    useChartTooltipStore(
      ({ payload, setData, fieldName, shouldShowMergeReason }) => ({
        payload,
        setData,
        fieldName,
        shouldShowMergeReason,
      }),
      shallow,
    );

  const openDrawer = () => {
    const activeMergeSuggestion = payload?.id
      ? {
          category: payload?.category,
          id: payload?.id || '',
          suggestedName: payload?.label || '',
          suggestedLabelsToMerge: [
            {
              id: payload?.id || '',
              label: payload?.label || '',
              category: payload?.category,
            },
          ],
        }
      : null;

    setData({
      activeMergeSuggestion,
      shouldShowConfirmMergeDrawer: true,
    });
    trackQuickFiltersEvents({
      eventName: 'Quick Filter Merge Reasons',
      triggerType: isMenuItem ? 'Table' : 'Chart',
    });
  };

  if (fieldName !== FieldNames.Reason) {
    return null;
  }

  if (!shouldShowMergeReason) {
    return null;
  }

  if (isMenuItem) {
    return (
      <MenuItem onClick={openDrawer}>
        <ListItemIcon>
          <MergeTypeRounded />
        </ListItemIcon>
        <ListItemText primary="Merge with another Reason" />
      </MenuItem>
    );
  }

  return (
    <>
      <ListItem divider disablePadding onClick={openDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <MergeTypeRounded />
          </ListItemIcon>
          <ListItemText primary="Merge with another Reason" />
        </ListItemButton>
      </ListItem>
    </>
  );
};
